import { CommonSelectors, Constants } from "@/libs/map-draw/lib-utils";
import {
  getTCBaseFeatures,
  createHoveredNodeHelper,
  clearAllHelpers,
  createLinkHelper,
  isPointInLinkArea,
  nearestPointOnLine
} from "@/libs/map-draw/helpers";

export const createDrawGeneralCountPointMode = (
  map,
  MapboxDraw,
  trafficCounts
) => {
  const DrawGeneralCountPoint = {};
  const customState = {
    hoveredFeatureId: "",
    no: "",
    fromnodeno: "",
    type: "",
    coordinates: "",
    nodeLinksLength: 0
  };

  DrawGeneralCountPoint.onTap = DrawGeneralCountPoint.onClick = function(
    state
  ) {
    const {
      hoveredFeatureId,
      coordinates,
      type,
      nodeLinksLength
    } = customState;

    if (hoveredFeatureId && coordinates) {
      if (type === "nodes" && nodeLinksLength < 3) return;
      this.updateUIClasses({ mouse: Constants.cursors.MOVE });
      state.point.updateCoordinate("", coordinates[0], coordinates[1]);
      if (type === "link") {
        state.point.setProperty("link_id", hoveredFeatureId);
        state.point.setProperty("node_id", null);
      } else {
        state.point.setProperty("node_id", hoveredFeatureId);
        state.point.setProperty("link_id", null);
      }

      trafficCounts.currentGCPoint = state.point;
      trafficCounts.editingCallback = point => {
        this.map.fire(Constants.events.CREATE, {
          features: [point.toGeoJSON()]
        });
        this.changeMode(Constants.modes.SIMPLE_SELECT, {
          featureIds: [state.point.id]
        });
        clearAllHelpers(this.map);
      };

      if (!trafficCounts.multi) {
        map.toggleGcpSettings(true);
      } else {
        // add feature id to multi ids
        trafficCounts.multiFeatures.push(state.point);
        // change mode to simple select
        this.changeMode(Constants.modes.SIMPLE_SELECT, {
          featureIds: [state.point.id]
        });
        clearAllHelpers(this.map);
      }

      trafficCounts.tcSettingsMode = "create";
    }
  };

  DrawGeneralCountPoint.onMouseMove = function(state, e) {
    const { lng, lat } = e.lngLat;
    const nodeFeatures = getTCBaseFeatures(this.map, map, e, "nodes");
    const linksFeatures = getTCBaseFeatures(this.map, map, e, "links");

    if (nodeFeatures.length) {
      const feature = nodeFeatures[0];
      const { coordinates } = feature.geometry;
      const { id, from_links } = feature.properties;
      const fromLinks = JSON.parse(from_links);

      if (customState.hoveredFeatureId !== id && fromLinks.length > 2) {
        clearAllHelpers(this.map);
        createHoveredNodeHelper(this.map, coordinates);
        customState.hoveredFeatureId = id;
        customState.nodeLinksLength = fromLinks.length;
        customState.coordinates = coordinates;
        customState.type = "node";
      }
    } else if (linksFeatures.length) {
      const link = linksFeatures.find(l =>
        isPointInLinkArea([lng, lat], l.geometry.coordinates, 50)
      );

      if (link) {
        if (link.properties.id !== customState.hoveredFeatureId) {
          clearAllHelpers(this.map);
          customState.hoveredFeatureId = "";

          createLinkHelper(
            this.map,
            link.geometry.type,
            link.geometry.coordinates
          );
          const { id } = link.properties;
          customState.hoveredFeatureId = id;
          customState.type = "link";
        }

        const nearest = nearestPointOnLine(
          [lng, lat],
          link.geometry.coordinates
        );
        const coordinates = nearest.geometry.coordinates;
        createHoveredNodeHelper(this.map, coordinates);
        customState.coordinates = coordinates;
      }
    } else {
      clearAllHelpers(this.map);
      customState.hoveredFeatureId = "";
      customState.type = "";
      customState.coordinates = null;
    }

    if (CommonSelectors.isVertex(e)) {
      this.updateUIClasses({ mouse: Constants.cursors.POINTER });
    }
  };

  return { ...MapboxDraw.modes.draw_point, ...DrawGeneralCountPoint };
};
